import { Maybe } from './Monadish';

export type Email = {
  address: string;
  domain: string;
  equals(compareValue: Maybe<string>): boolean;
};

const getDomain = (value: string): string => value.split('@').pop()?.trim() ?? '';

const equalsInsensitive =
  (value: string) =>
  (compareValue: Maybe<string>): boolean =>
    value.toLowerCase().trim() === compareValue?.toLowerCase().trim();

const fromDto = (value: string): Email => ({
  address: value,
  domain: getDomain(value),
  equals: equalsInsensitive(value),
});

const fromUserInput = (value: string): Email => ({
  address: value.toLowerCase().trim(),
  domain: getDomain(value),
  equals: equalsInsensitive(value),
});

const fromUserInputOrUndefined = (value: Maybe<string>): Maybe<Email> =>
  value
    ? {
        address: value.toLowerCase().trim(),
        domain: getDomain(value),
        equals: equalsInsensitive(value),
      }
    : undefined;

export const Email = {
  fromDto,
  fromUserInput,
  fromUserInputOrUndefined,
};
